import { useMemo, useRef } from "react"
import { MemoriesApi, Memory } from "@common/types/memory"
import { useAuthHeader } from "../context/AuthContext"
import {
  UserLearning,
  getUserLearnings,
  updateUserLearning,
  deleteUserLearning,
  runLearnings,
} from "../utils/learnings-api"

export interface LearningsApi extends MemoriesApi {
  run: () => Promise<void>
}

const toMemory = (learning: UserLearning): Memory => ({
  id: learning.id,
  conversationId: "",
  contentText: learning.content,
  contextText: learning.description,
  createdAt: learning.updatedAt,
  tags: [],
})

export function useLearningsApi(): LearningsApi {
  const authHeader = useAuthHeader()
  const authHeaderRef = useRef(authHeader)
  authHeaderRef.current = authHeader

  return useMemo<LearningsApi>(() => {
    const requireAuth = () => {
      const header = authHeaderRef.current
      if (!header) throw new Error("Not authenticated")
      return header
    }

    return {
      list: async () => (await getUserLearnings(requireAuth())).map(toMemory),
      remove: id => deleteUserLearning(requireAuth(), id),
      update: async (id, fields) =>
        toMemory(
          await updateUserLearning(requireAuth(), id, {
            content: fields.contentText,
            description: fields.contextText,
          }),
        ),
      addTag: async () => {},
      removeTag: async () => {},
      searchTags: async () => [],
      supportsTags: false,
      run: () => runLearnings(requireAuth()),
    }
  }, [])
}
